<script>
  import { onMount } from 'svelte'
  import { querystring } from "svelte-spa-router"
  import { accessTokenRefresh } from '../tokenFunction';
  import { push } from "svelte-spa-router";
  import { api } from '../helpers';

  export let params = {}

  const loginLogging = async (from_mobile) => {
    api('/api/v1/logging/basis/create/open-spa-tab/', 'POST', JSON.stringify({ from_mobile }), true)
      .catch((error) => console.error(error));
  }

  onMount(async () => {
    const searchParams = new URLSearchParams($querystring)
    const publicationId = searchParams.get('publ_id')
    const isMobileApp = searchParams.get('from_mobile')
    const nextUrl = searchParams.get('next')

    const phtUrl = searchParams.get('url_redirect');

    localStorage.setItem('pht_url', phtUrl);
    localStorage.setItem('refresh_token', params.refresh_token)
    localStorage.setItem('from_mobile', isMobileApp)
    localStorage.setItem('next_url', nextUrl);
    
    await accessTokenRefresh()
    await loginLogging(!!isMobileApp)

    if (publicationId) {
      push(`/publicate/${publicationId}`)
      return
    }

    if (nextUrl && isMobileApp) {
      push(nextUrl)
      return
    }
    
    push('/')
  });
</script>

